import {
  defaultAgregationRequest,
  defaultAllCasesPageRequest,
  defaultAllCasesRequestFields
} from '../../pages/Cases/constants/CasesConstants';
import axiosInstance, { ApiKeys, getApiUrl } from '../../utils/ApiHelper';
import { pushToLocalStorage } from '../../utils/StorageUtils';
import { LOCAL_STORAGE_KEYS } from '../../constants/StorageKeys';
import { setTelephones } from '../../pages/CaseDetails/reducers/caseDetailSlice';

export const getCustomerReferenceIdFromLAN = (loanId: string, successCallback: any) => {
  const url = getApiUrl(ApiKeys.FETCH_ALL_CASES);
  const payload = {
    ...defaultAllCasesPageRequest,
    aggregationRequest: defaultAgregationRequest,
    ...defaultAllCasesRequestFields,
    query: loanId
  };
  if (payload && !payload.paymentStatus) {
    payload.paymentStatus = ['ALL'];
  }
  pushToLocalStorage(LOCAL_STORAGE_KEYS.ALLOCATED_CASES_PAGE_REQUEST, payload);
  return axiosInstance.post(url, payload).then(response => {
    if (response.data?.caseSummaryPaginatedResponse?.data) {
      successCallback(loanId, response.data?.caseSummaryPaginatedResponse?.data?.[0]);
    }
    return response?.data?.caseSummaryPaginatedResponse?.data?.[0];
  });
};

export const getTelephones = (
  loanAccountNumber: string,
  customerReferenceId: string,
  caseReferenceId: string,
  caseBusinessVertical: string,
  successCallback: any
) => {
  return axiosInstance
    .get(getApiUrl(ApiKeys.TELEPHONES), {
      headers: { customerReferenceId, loanAccountNumber, caseReferenceId, caseBusinessVertical }
    })
    .then(res => {
      if (res.data) {
        successCallback(res.data);
        return res?.data;
      }
    });
};
